import { render, staticRenderFns } from "./SidebarNavItems.vue?vue&type=template&id=e4a45c10&"
import script from "./SidebarNavItems.vue?vue&type=script&lang=js&"
export * from "./SidebarNavItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports